import { IAppState } from '../../../AppModulesWrapper';

export function selectBusinessCenterId(state: IAppState): number | undefined {
  return state.servicePickerWidget.offer.businessShoppingCenter?.id;
}
